import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  companyProcessFetchCompanyProcess: null,
  companyProcessFetchCompanyProcessLoading: ['boolean'],
  companyProcessFetchCompanyProcessSuccess: ['process']
});

export const CompanyProcessTypes = Types;
export default Creators;
